let isLoading = false; // Prevent overlapping loads

const loadItems = (button) => {
    const totalPages = parseInt($("[data-total-pages]").val());
    let currentPage = parseInt($("[data-current-page]").val());
    const nextUrlElement = $("[data-next-url]");
    let nextUrlValue = nextUrlElement.val();

    if (isLoading || currentPage >= totalPages || !nextUrlValue) {
        document.querySelector(".spinner").style.display = "none";
        if (button) button.remove();
        return;
    }

    isLoading = true;
    const nextUrl = nextUrlValue;


    button.setAttribute("disabled", "");
    button.classList.add("loading");

    $.ajax({
        url: nextUrl,
        type: "GET",
        dataType: "html",
success: function (responseHTML) {
    console.log(" Load More clicked");
    console.log(" Loading page:", currentPage + 1);
    console.log(" Next URL:", nextUrl);

    const newProducts = $(responseHTML).find(".load-more-grid").children();
    console.log(" Number of products fetched:", newProducts.length);

    newProducts.each(function () {
        $(".load-more-grid")[0].appendChild(this.cloneNode(true));
    });

    currentPage += 1;

    // Get the updated cursor URL from the response
    const updatedUrl = $(responseHTML).find("[data-next-url]").val();

    nextUrlElement.val(updatedUrl).attr("data-next-url", updatedUrl);
    $("[data-current-page]").val(currentPage).attr("data-current-page", currentPage);

    console.log(" Updated currentPage:", currentPage);
    console.log(" Updated next URL:", updatedUrl);

    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
}

,
        complete: function () {
            isLoading = false;

            if (currentPage >= totalPages) {
                document.querySelector(".spinner").style.display = "none";
                if (button) button.remove();
            } else {
                button.removeAttribute("disabled");
                button.classList.remove("loading");
            }
        },
    });
};

function loadMore() {
    const loadMoreButtons = document.querySelectorAll(".js-load-more");

    loadMoreButtons.forEach((button) => {
        button.onclick = () => {
            loadItems(button);
        };
    });

    checkVisibility();
}

(function () {
    loadMore();
})();
